/**
 * 专门做布局控制
 * 1. 首页主题切换
 * 2. 广播位置切换
 */

/**
 * 关于是否 弹性布局
 * portalTheme 可设置值为 0,1,2,3
 * 1 为弹性布局
 * 然后 0， 1 需要固定底部(fixed)
 * 2,3已合并为一个主题
 */

const broadcastTypeList = ['top', 'middle', 'bottom'];
class Theme {
  // 是否弹性布局，弹性布局会根据宽度自适应，不定宽
  enableScale = true;
  // 是否顶部固定
  enableFixBottom = true;
  // 广播位置 'top'|'middle'|'bottom'
  broadcastType = 'middle';

  constructor(options) {
    if (!options) return;
    const { portalTheme, announcementPosition = 1 } = options;
    this.setScale(portalTheme);
    this.setFixBottom(portalTheme);
    this.setBroadcastType(announcementPosition);
  }

  setScale(portalTheme) {
    this.enableScale = +portalTheme === 1;
  }

  setFixBottom(portalTheme) {
    const themeType = +portalTheme;
    const isFix = themeType === 1 || themeType === 0;
    this.enableFixBottom = isFix;
  }

  setBroadcastType(announcementPosition = 1) {
    const maxPosition = broadcastTypeList.length - 1;
    if (announcementPosition <= maxPosition) {
      const position = broadcastTypeList[announcementPosition];
      // 伸缩布局时，加料
      // 目的: 撑满全屏的首页布局，广播不能放在下方，如果设置成下方了，要换成在中间
      if (this.isScale() && position === 'bottom') {
        // nothing
      } else {
        this.broadcastType = position;
      }
    }
  }

  isScale() {
    return this.enableScale;
  }

  isTopBroadcast() {
    return this.broadcastType === 'top';
  }

  isMiddleBroadcast() {
    return this.broadcastType === 'middle';
  }

  isBottomBroadcast() {
    return this.broadcastType === 'bottom';
  }

  isFixedBottom() {
    return this.enableFixBottom;
  }

  getBroadcastPosition() {
    return this.broadcastType;
  }

  getHeaderHeight() {
    const topBarHeight = (document.querySelector('.js-topBar') || {}).clientHeight || 0;
    const topHeight = (document.querySelector('.js-header') || {}).clientHeight || 0;
    return topBarHeight + topHeight;
  }

  getContentHeight() {
    const topBarHeight = (document.querySelector('.js-topBar') || {}).clientHeight || 0;
    const topHeight = (document.querySelector('.js-header') || {}).clientHeight || 0;
    const bottomHeight = (document.querySelector('.footer-location') || {}).clientHeight || 0;
    const stickyHeight = topBarHeight + topHeight + (this.enableFixBottom ? bottomHeight : 0) + 1;
    return stickyHeight;
  }
}

export default Theme;
